export default "__VITE_ASSET__6MsSE1Km__"